import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Routes } from '@angular/router';
import { WorklistComponent } from '@modules/worklist/components/worklist/worklist.component';
import { AuthGuard } from '@core/security/auth.guard';
import { WorklistIssuesComponent } from '@modules/worklist/modules/worklist-issues/components/worklist-issues/worklist-issues.component';

const routes: Routes = [
    {
        path: '',
        runGuardsAndResolvers: 'always',
        canActivate: [AuthGuard],
        component: WorklistComponent,
        children: [
            {
                path: 'to-do',
                runGuardsAndResolvers: 'always',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        '../worklist/modules/worklist-todo/worklist-todo.module'
                    ).then((module) => module.WorklistTodoModule),
            },
            {
                path: 'notifications',
                runGuardsAndResolvers: 'always',
                canActivate: [AuthGuard],
                loadChildren: () =>
                    import(
                        '../worklist/modules/worklist-notification/worklist-notification.module'
                    ).then((module) => module.WorklistNotificationModule),
            },
            /*{
                path: 'issues',
                runGuardsAndResolvers: 'always',
                canActivate: [AuthGuard],
                component: WorklistIssuesComponent,
            },*/
        ],
    },
];

@NgModule({
    declarations: [],
    imports: [CommonModule, RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class WorklistRoutingModule {}
